import type { FaireProductEntity } from "../../entity_types/product";

export const p_c8w3nxfgu9: FaireProductEntity = {
  token: "p_c8w3nxfgu9",
  type: "product",
  name: "HANDSOME HIGHLAND COW SQUISHY",
  brandToken: "b_weuw966vgj",
  brandName: "Learning Lane Sensory Toys",
  imageUrl:
    "https://cdn.faire.com/fastly/a4b49f68218fe8397e2019cc7cd940125596cc3968ee318003e3bdbec50d895e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d9cbabed334693bd82d1f4d9b712f3988773ec34ff2acd1d8abce4561cae7df8.png",
    "https://cdn.faire.com/fastly/35af82e97a2f4df88747b25e65995e087d631435cb8c5f0fac107f1e64f997dc.png",
    "https://cdn.faire.com/fastly/e74cb41d899a13f0a2a018ebd9987c0ef4a46fb898917fc1943f1b8a808c35c9.png",
  ],
  priceDollars: 4.15,
  description:
    "HERE A HIGHLAND COW,  THERE A HIGHLAND COW, EVERYWHERE A HIGHLAND COW!!  THESE HANDSOME LITTLE GUYS WILL BE A FAST FAN FAVORITE!\n\nSAFETY WARNING: This product contains chemical compounds used in manufacturing. Keep away from children under 6 years of age. Do not place in mouth or chew. Do not puncture, cut, or tear the outer surface. If the product is damaged or torn, discontinue use immediately and dispose of properly — do not allow contact with the inner foam material. Wash hands after extended handling. Keep away from eyes, nose, and mouth. Not intended for children who mouth objects. Store in a cool, dry place away from direct sunlight and heat. This product is not a food item. In case of accidental ingestion of inner material, contact Poison Control immediately at [redacted-phone]. Adult supervision recommended for young children.",
  tags: [],
  msrpDollars: 7.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:28.878Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
